module.exports = __webpack_public_path__ + "img/w25.26a42ea5.svg";